<template>
    <div class="column is-narrow-desktop is-one-third-touch is-centered is-flex is-horizontal-center">
        <figure class="image is-64x64 has-text-centered" v-on:click="setComponentActive">
            <img :src="'/static/images/types/' + type + '.png'">
            <span :class="{ 'is-active-type': isActive }">{{ type }}</span>
        </figure>
    </div>
</template>

<script>
    export default {
        props: ['type', 'isActive', 'index'],
        methods: {
            setComponentActive: function () {
                this.$store.dispatch('changeActiveElement', this.index)
            }
        }
    }
</script>

<style scoped>
    .is-horizontal-center {
        justify-content: center;
    }
    .is-active-type {
        color: #3273dc
    }
    figure {
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/Auctions/Model/AuctionBrandType.vue